import { prop, pick } from 'ramda';
import React, { memo } from 'react';
import parse from 'html-react-parser';
import { getHTMLParserOptions } from 'js/utils/getHTMLParserOptions.util';
import { useGameConfigurationSelector, useUserSelector } from 'js/store/hooks';

import * as Types from './types';
import * as helpers from './helpers';
import * as constants from '../../constants';
import { TGameConfiguration } from '../../types';

import style from './GameViewCustomHover.scss';

export const GameViewCustomHoverBare: React.FC<Types.IGameViewCustomHoverProps> = ({ game }) => {
    const lang = useUserSelector(prop('lang'));
    const { basicGameTileLayout, liveGameTileLayout } = useGameConfigurationSelector(pick(['basicGameTileLayout', 'liveGameTileLayout'])) || {};

    const layout = game?.isLiveGame ? liveGameTileLayout : basicGameTileLayout;
    const { gameTileLayoutHoverCustomTemplate = [] } = layout || {};

    const { options } = getHTMLParserOptions<{game: TGameConfiguration}, any>(
        { componentAttributes: { game }, components: constants.components }
    );
    const template = helpers.getCustomTemplate({ lang, customTemplates: gameTileLayoutHoverCustomTemplate });

    return <div className={`${style.hoverContainerCustom} cms-games-grid-game-hover-state-custom`}>{parse(template, options)}</div>;
};

export const GameViewCustomHover = memo(GameViewCustomHoverBare);
